export interface VerificationTiming {
  durationMs: number;
  scope: 'start_to_result_received';
}

export const verificationTimingScope = 'Measured by the server from the start of the run to the saved result: extraction, independent readings, screening, consolidation and saving. Excludes uploading the files.';

export function verificationTimeLabel(timing?: VerificationTiming): string {
  return timing?.scope === 'start_to_result_received' && Number.isFinite(timing.durationMs) && timing.durationMs >= 0
    ? `${(timing.durationMs / 1000).toFixed(1)}s` : 'Unavailable';
}
